/**
 * Smooth Anchor Scroll
 * Handles smooth scrolling for anchor links (e.g., Learn More CTAs)
 */
export default class SmoothAnchorScroll {
  constructor() {
    this.init();
  }

  init() {
    // Handle all anchor links on the page
    this.setupAnchorLinks();
  }

  setupAnchorLinks() {
    // Select all links that start with #
    const anchorLinks = document.querySelectorAll('a[href^="#"]:not([href="#"])');
    
    anchorLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        const href = link.getAttribute('href');
        const targetId = href.substring(1); // Remove the # symbol
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
          e.preventDefault();
          
          // Smooth scroll to the target element
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest'
          });

          // Update URL hash without jumping
          if (history.pushState) {
            history.pushState(null, null, href);
          } else {
            // Fallback for older browsers
            window.location.hash = href;
          }
        }
      });
    });
  }

  /**
   * Scroll to element with offset for fixed header
   * @param {HTMLElement} element - Target element
   * @param {number} offset - Offset in pixels (default: 100)
   */
  static scrollToElementWithOffset(element, offset = 100) {
    if (!element) return;

    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - offset;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  /**
   * Handle scroll on page load if there's a hash in URL
   */
  static scrollOnLoad() {
    if (window.location.hash) {
      const hash = window.location.hash;
      const targetId = hash.substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
        // Small delay to ensure page is fully rendered
        setTimeout(() => {
          SmoothAnchorScroll.scrollToElementWithOffset(targetElement);
        }, 100);
      }
    }
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new SmoothAnchorScroll();
  SmoothAnchorScroll.scrollOnLoad();
});
